export default "__VITE_ASSET__BSR2gRQS__"